import { Component, OnInit, Output, EventEmitter }
    from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ApplicationClaim, AccountApplicationClaim, ApplicationAccessWorkflow }
    from "../../../models";
import { CurrentUserService, UserAuthenticationService }
    from "../../../services/shared";
import { NgProgressService } from "ng2-progressbar";
import { USERHOMECONSTANTS } from "../../../modules/userHome";
import { WORKFLOWCONSTANTS } from "../workflow.constants";
import { ApplicationAccessWorkflowService } from "./applicationAccessWorkflow.service";
const _ = require("underscore");
const swal = require("sweetalert2");

@Component({
    selector: "applicationAccessWorkflow-component",
    template: require("./applicationAccessWorkflow.component.html"),
    styles: [require("./applicationAccessWorkflow.component.less").toString()],
    providers: [ApplicationAccessWorkflowService]
})

export class ApplicationAccessWorkflowComponent implements OnInit {
    @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
    @Output() handleRejectProcessing: EventEmitter<any> = new EventEmitter();
    applicationAccessClaimDetails = new AccountApplicationClaim();
    applicationAccessWorkflow: ApplicationAccessWorkflow;
    workflowTaskId: string;
    errorMessage: string;
    errors: Error[];
    loggedIn: boolean = false;
    isProcessing: boolean;
    isRejectProcessing: boolean;
    hasEditPermission: boolean;
    applicationClaims: ApplicationClaim[];
    constructor(private currentUserService: CurrentUserService,
        private userAuthService: UserAuthenticationService,
        private cecRouter: Router,
        private cecActivatedRoute: ActivatedRoute,
        private pService: NgProgressService,
        private applicationAccessWorkflowService: ApplicationAccessWorkflowService) {
    }

    ngOnInit() {
        this.isProcessing = false;
        this.isRejectProcessing = false;
        this.applicationAccessClaimDetails = new AccountApplicationClaim();
        this.applicationAccessClaimDetails.applicationClaims = [new ApplicationClaim()];
        if (!this.userAuthService.isAuthenticated) {
            this.cecRouter.navigate(["/login"]);
            return;
        }

        this.errorMessage = "";
        // Apply security rules
        let token = this.currentUserService.token;
        
        // Global admins, diocesan admin and organisation admin can edit contact details or logged in user can edit own contact details
        this.hasEditPermission = this.currentUserService.IsGlobalAdmin() ||
                                this.currentUserService.IsDiocesanAdmin() ||
                                this.currentUserService.IsOrgAdmin() ||
                                (token && !this.cecActivatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.accountId]);
        
        if (!this.hasEditPermission) {
            this.errorMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
            return;
        }

        this.pService.start();
        this.applicationAccessWorkflow = new ApplicationAccessWorkflow();
        this.workflowTaskId = this.cecActivatedRoute.snapshot.params[WORKFLOWCONSTANTS.params.taskId];
        if (this.workflowTaskId) {
            this.applicationAccessWorkflow.taskId = this.workflowTaskId;
            this.getApplicationAccessWorkflowByTaskId(this.workflowTaskId);

        }

        this.pService.done();
    }

    onApplicationAccessApprove() {
        this.errorMessage = "";
        this.errors = [];
        this.submitApproveRequest(this);
    }

    onApplicationAccessReject() {
        this.errorMessage = "";
        this.errors = [];
        this.submitRejectRequest(this);
    }

    onGoBack() {
        this.goBackToTasks();
    }

    onHandleProcessing(isProcessing) {
        this.isProcessing = isProcessing;
    }

    onHandleRejectProcessing(isRejectProcessing) {
        this.isRejectProcessing = isRejectProcessing;
    }

    goBackToTasks(): void {
        let tabId = this.cecActivatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.tabId];
        if (!tabId) {
            tabId = USERHOMECONSTANTS.tabIds.tasksId;
        }
        let navigationExtras = {
            queryParams: { "tabId": tabId }
        };
        this.cecRouter.navigate(["/myhome"], navigationExtras);
    }

    submitApproveRequest(applicationAccessWorkflowComponent: ApplicationAccessWorkflowComponent) {
        swal({
            title: "Are you sure?",
            text: "You want to approve this application access request.",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        }).then(function () {
            applicationAccessWorkflowComponent.processApproveRequest();
        }, function (dismiss) {
        });
    }

    processApproveRequest() {
        this.pService.start();
        this.errorMessage = "";
        this.isProcessing = true;
        this.handleProcessing.emit(true);
        this.applicationAccessWorkflow.statusCode = USERHOMECONSTANTS.organisationApplicationClaimStatusTypes.active;
        this.applicationAccessWorkflowService
            .submitApplicationAccessWorkflow(this.applicationAccessWorkflow)
            .subscribe(
            (response: boolean) => {
                if (response === true) {
                    swal(
                        "Done!",
                        USERHOMECONSTANTS.messages.requestSuccessfull,
                        "success"
                    );
                } else {
                    swal(
                        "Failed!",
                        USERHOMECONSTANTS.messages.requestFailed,
                        "error"
                    );
                }
                this.goBackToTasks();
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                this.errorMessage = USERHOMECONSTANTS.messages.requestFailed;
                if (paersedErrors) {
                    paersedErrors.message = this.errorMessage;
                    let popupMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
                    this.errors = paersedErrors.errors;
                    if (this.errors) {
                        popupMessage = this.errors[0].message;
                    }
                    swal(
                        paersedErrors.message,
                        popupMessage,
                        "error"
                    );
                }
            })
            .add(t => {
                this.isProcessing = false;
                this.handleProcessing.emit(false);
                this.pService.done();
            });
    }

    submitRejectRequest(applicationAccessWorkflowComponent: ApplicationAccessWorkflowComponent) {
        swal({
            title: "<h3>Reason for rejecting the application access request</h3>",
            text: applicationAccessWorkflowComponent.applicationAccessWorkflow.comment,
            type: "warning",
            input: "text",
            showCancelButton: true,
            confirmButtonText: "Submit",
            showLoaderOnConfirm: true,
            animation: "slide-from-top",
            inputPlaceholder: "Comment on rejection",
            preConfirm: function (inputValue) {
                return new Promise(function (resolve, reject) {
                    if (!inputValue) {
                        reject("Your comment is required!");
                    } else {
                        resolve();
                    }
                });
            },
            allowOutsideClick: false
        }).then(function (inputValue) {
            applicationAccessWorkflowComponent.applicationAccessWorkflow.comment = inputValue;
            applicationAccessWorkflowComponent.processRejectRequest();
        }, function (dismiss) {
        });
    }

    processRejectRequest() {
        this.pService.start();
        this.errorMessage = "";
        this.isRejectProcessing = true;
        this.handleRejectProcessing.emit(true);
        this.applicationAccessWorkflow.statusCode = USERHOMECONSTANTS.organisationApplicationClaimStatusTypes.inActive;
        this.applicationAccessWorkflowService
            .submitApplicationAccessWorkflow(this.applicationAccessWorkflow)
            .subscribe(
            (response: boolean) => {
                if (response === true) {
                    swal("Done!",
                        USERHOMECONSTANTS.messages.requestSuccessfull,
                        "success");
                } else {
                    swal("Failed!",
                        USERHOMECONSTANTS.messages.requestFailed,
                        "error");
                }
                this.goBackToTasks();
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                this.errorMessage = USERHOMECONSTANTS.messages.requestFailed;
                if (paersedErrors) {
                    paersedErrors.message = this.errorMessage;
                    let popupMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
                    this.errors = paersedErrors.errors;
                    if (this.errors) {
                        popupMessage = this.errors[0].message;
                    }
                    swal(
                        paersedErrors.message,
                        popupMessage,
                        "error"
                    );
                }
            })
            .add(t => {
                this.isRejectProcessing = false;
                this.handleRejectProcessing.emit(false);
                this.pService.done();
            });
    }

    loadApplicationClaims(appId: string): void {
        this.applicationAccessWorkflowService.getApplicationClaims(appId)
            .subscribe(
            (response: ApplicationClaim[]) => {
                if (response) {
                    // if not a global admin, then remove the Admin permission from the drop down.                     
                    if (!(this.currentUserService.IsGlobalAdmin())) {
                        for (let i = 0; i < response.length; i++) {
                            if (response[i].name === "Administrator") {
                                response.splice(i, 1);
                            }
                        }
                    }
                    this.applicationClaims = response;
                }
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                this.errorMessage = WORKFLOWCONSTANTS.messages.commonWorkflowErrorMessage;
                if (paersedErrors) {
                    this.errors = paersedErrors.errors;
                }
            });
    }

    getApplicationAccessWorkflowByTaskId(taskId: string): void {
        this.applicationAccessWorkflowService
            .getApplicationAccessWorkflowByTaskId(taskId, USERHOMECONSTANTS.taskTypeCodes.applicationAccess)
            .subscribe(
            (response: ApplicationAccessWorkflow[]) => {
                if (response) {
                    this.applicationAccessWorkflow.accountOrganisationApplicationClaimId = response[0].accountOrganisationApplicationClaimId;
                    this.applicationAccessWorkflowService
                        .getAccountOrganisationApplicationClaimById(response[0].accountOrganisationApplicationClaimId)
                        .subscribe(
                        (appAccessResponse: AccountApplicationClaim) => {
                            this.applicationAccessClaimDetails = appAccessResponse;
                            this.applicationAccessWorkflow.accountOrganisationId = this.applicationAccessClaimDetails.accountOrganisationId;
                            this.applicationAccessWorkflow.userId = this.applicationAccessClaimDetails.userId;
                            this.applicationAccessWorkflow.applicationClaimId = this.applicationAccessClaimDetails.applicationClaims[0].applicationClaimId;
                            this.loadApplicationClaims(this.applicationAccessClaimDetails.applicationId);
                        },
                        (accountError) => {
                            let paersedErrors = JSON.parse(accountError._body);
                            this.errorMessage = WORKFLOWCONSTANTS.messages.commonWorkflowErrorMessage;
                            if (paersedErrors) {
                                this.errors = paersedErrors.errors;
                            }
                        })
                        .add(t => {
                            this.pService.done();
                        });
                } else {
                    this.errorMessage = WORKFLOWCONSTANTS.messages.commonWorkflowErrorMessage;
                }
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                this.errorMessage = WORKFLOWCONSTANTS.messages.commonWorkflowErrorMessage;
                if (paersedErrors) {
                    this.errors = paersedErrors.errors;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/workflow/applicationAccess/applicationAccessWorkflow.component.ts